import { useMemo } from "react"
import _ from "lodash"

import { IFeature } from "interfaces"
import { PromotionData } from "providers/venue/types"
import {
  getOccupantDetail,
  IMultiLanguageInfo,
  IOccupantDetail,
} from "utils/feature"

import { useGetPromotions, useGetOccupant } from "providers/venue/modules/data"
import { useMobileUrl } from "hooks/useMobileUrl"

export interface IUseOccupantPromotionResult extends IOccupantDetail {
  occupantName: IMultiLanguageInfo | string
  promotions: Partial<PromotionData>[]
  mobileUrl: string
}

export type UseOccupantPromotion = (
  occupantId: string
) => IUseOccupantPromotionResult

export const useOccupantPromotion: UseOccupantPromotion = (occupantId) => {
  const { mobileUrl } = useMobileUrl({ path: "/maps/place/" })
  const { data: occupant } = useGetOccupant(occupantId)
  const { data: promotions } = useGetPromotions()

  const occupantDetail = useMemo(() => {
    return (
      occupant ? getOccupantDetail(occupant as unknown as IFeature) : {}
    ) as IOccupantDetail
  }, [occupant])

  const occupantPromotions = useMemo(
    () =>
      promotions.filter(
        (promotion) => promotion.properties.feature?.id === occupantId
      ),
    [promotions, occupantId]
  )

  const sortedPromotions = useMemo(
    () =>
      _.orderBy(
        occupantPromotions,
        [
          "properties.is_featured",
          "properties.start_date",
          "properties.end_date",
        ],
        ["desc", "asc", "asc"]
      ),
    [occupantPromotions]
  )

  return {
    ...occupantDetail,
    mobileUrl,
    occupantName: occupantDetail.name,
    promotions: sortedPromotions,
  }
}
